module.exports = __webpack_public_path__ + "img/45e7707.jpg";